import * as React from 'react'

import Timeline from './Timeline'
import { TimelineProps } from './timelineProps'

export const TimelineWeekly: React.FC<TimelineProps> = (props) => {
  return (
    <Timeline
      {...props}
      days={props.days ?? 7}
      weekly
      simpleMode={false}
      showRests={props.showRests ?? true}
      showRestParts={props.showRestParts ?? false}
      cardInserts={[]}
      dayActivities={[]}
      violations={[]}
      dailyRests={[]}
      dailyPartialRegularRests={[]}
      weeklyRests={props.weeklyRests ?? []}
      weeklyReducedRests={props.weeklyReducedRests ?? []}
      partialBreaks={[]}
      weekRecompenses={props.weekRecompenses ?? []}
      outOfScopes={[]}
      tmsData={[]}
      minimalPaymentCountries={[]}
      changeAreas={[]}
      existingDelegations={[]}
      periodSelections={[]}
      delegationMarkers={[]}
      allTripEvents={[]}
      allPreviousTripEvents={[]}
      allEvents={[]}
    />
  )
}

TimelineWeekly.displayName = 'TimelineWeekly'
